import classNames from "classnames";
import React from "react";

import { useChildrenArray } from "../../lib/helpers/hooks/useChildrenArray";
import { ChevronRightIcon, LoadingSpinnerIcon } from "../AscIcons";
import {
  AscAdminBreadcrumbItem,
  AscAdminBreadcrumbItemProps,
} from "./AscAdminBreadcrumbItem/AscAdminBreadcrumbItem";

import style from "./AscAdminBreadcrumbs.module.scss";

export interface AscAdminBreadcrumbsProps {
  children: JSX.Element[];
  className?: string;
  breadcrumbItemClassName?: string;
}

function AscAdminBreadcrumbs({
  children,
  className,
  breadcrumbItemClassName,
}: AscAdminBreadcrumbsProps) {
  const crumbs = useChildrenArray<AscAdminBreadcrumbItemProps>(children || []);

  return (
    <ul className={classNames(style.ground, className)}>
      {crumbs.map((crumb, index) => {
        return (
          <React.Fragment key={index}>
            <div className={style.link}>
              <li
                onClick={crumb?.loading ? () => ({}) : crumb?.onClick}
                className={classNames(
                  style.breadcrumbItem,

                  crumb?.className,
                  breadcrumbItemClassName
                )}
              >
                {crumb?.loading ? (
                  <LoadingSpinnerIcon className={style.loadingIcon} />
                ) : (
                  crumb?.children
                )}
              </li>
            </div>
            <span className={style.separator}>
              <ChevronRightIcon className={style.icon} />
            </span>
          </React.Fragment>
        );
      })}
    </ul>
  );
}

AscAdminBreadcrumbs.Item = AscAdminBreadcrumbItem;

export default AscAdminBreadcrumbs;
